import React, { useState, useEffect } from 'react'
import { postAPI } from '../../../app/api';
import memories01 from "../../../assets/img/memories-01.png"
import memories02 from "../../../assets/img/memories-02.png"
const API_BASE_URL = process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/';
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';
const getImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
    }
    // Otherwise, prepend the API base URL
    return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl.slice(1) : imageUrl}`;
};

export default function Memories() {
    const [memoriesList, setMemoriesList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const fetchMemoriesSection = async () => {
        try {
            const response = await postAPI('homepage-highlights/listPublished', {});
            if (response?.status === 1) {
                setMemoriesList(response?.data || []);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        fetchMemoriesSection();
    }, []);
    useEffect(() => {
        if (memoriesList.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % memoriesList.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [memoriesList.length]);
    const currentMemory = memoriesList[currentIndex] || {};
    const backImgUrl = getImageUrl(currentMemory?.back_img) || memories01;
    const frontImgUrl = getImageUrl(currentMemory?.front_img) || memories02;
    const goToPrev = () => {
        setCurrentIndex((prev) => (prev - 1 + memoriesList.length) % memoriesList.length);
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % memoriesList.length);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        console.log('MemoriesList data:', memoriesList);
    }, [memoriesList]);

    return (
        <>
            <section className="memories">
                <div className="container-xxl container-xl container-fluid">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-4 col-md-5 memories-image">
                            <figure className="one">
                                <img
                                    src={backImgUrl}
                                    className="img-fluid"
                                    alt="Memory 1"
                                    onError={(e) => { e.target.src = memories01; }}
                                    style={{ transition: 'opacity 0.5s ease-in-out' }}
                                />
                            </figure>
                            <figure className="two">
                                <img
                                    src={frontImgUrl}
                                    className="img-fluid"
                                    alt="Memory 2"
                                    onError={(e) => { e.target.src = memories02; }}
                                    style={{ transition: 'opacity 0.5s ease-in-out' }}
                                />
                            </figure>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <h2 style={{ transition: 'opacity 0.5s ease-in-out' }}>
                                {currentMemory?.highlight_text || 'স্মৃতির পাতায় মিহির দা'}
                                <img src={`${HTML_ASSETS_URL}assets/images/icon/5934209.svg`} alt="Icon" />
                            </h2>
                            <div className="paragraph" style={{ transition: 'opacity 0.5s ease-in-out' }}>
                                <p>
                                    {currentMemory?.description || 'মিহির কুমার দা ছিলেন আমাদের ক্লাবের অন্যতম প্রিয় ও শ্রদ্ধেয় সদস্য তাঁর আন্তরিকতা, নিষ্ঠা ও সহমর্মিতা আজও আমাদের পথ দেখায় তিনি শুধু একজন সদস্য নন, ছিলেন এক অনুপ্রেরণা — যাঁর হাসি, পরামর্শ ও উপস্থিতি আমাদের ক্লাবকে আরও সমৃদ্ধ করেছে'}
                                </p>
                                {currentMemory?.blockquote && <span>{currentMemory?.blockquote || '05/06/1921 - 06/12/2021'}</span>}
                            </div>


                            {memoriesList.length > 1 && (
                                <div className="memories-slider-nav" style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>

                                    <button
                                        onClick={goToPrev}
                                        style={{
                                            background: 'transparent',
                                            border: '2px solid #6c757d',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                        aria-label="Previous memory"
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <polyline points="15,18 9,12 15,6"></polyline>
                                        </svg>
                                    </button>


                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        {memoriesList.map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => goToSlide(index)}
                                                style={{
                                                    width: currentIndex === index ? '24px' : '10px',
                                                    height: '10px',
                                                    borderRadius: '5px',
                                                    border: 'none',
                                                    background: currentIndex === index ? '#007bff' : '#dee2e6',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                aria-label={`Go to memory ${index + 1}`}
                                            />
                                        ))}
                                    </div>


                                    <button
                                        onClick={goToNext}
                                        style={{
                                            background: 'transparent',
                                            border: '2px solid #6c757d',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                        aria-label="Next memory"
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <polyline points="9,18 15,12 9,6"></polyline>
                                        </svg>
                                    </button>


                                    <span style={{
                                        fontSize: '14px',
                                        color: '#6c757d',
                                        marginLeft: '10px'
                                    }}>
                                        {currentIndex + 1} / {memoriesList.length}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
